import React from 'react';

import { Wrap } from '@components';
import { Outlet } from 'react-router-dom';

const WithdrawalGuidePage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default WithdrawalGuidePage;
